// src/api_auth.js
import { http } from "./http";

/**
 * Restituisce:
 * {
 *   authenticated: boolean,
 *   requires_setup: boolean,
 *   user_id: number|null,
 *   azienda_id: number|null
 * }
 */
export async function checkSession() {
  const { data } = await http.get("/api/session_info.php");

  return {
    // ✅ SOLO true se è proprio boolean true
    authenticated: data?.authenticated === true,

    // ✅ SOLO true se è proprio boolean true (evita "false" -> true)
    requires_setup: data?.requires_setup === true,

    user_id: data?.user_id ?? null,
    azienda_id: data?.azienda_id ?? null,
  };
}